import React from 'react'
import Lottie from 'react-lottie'
import Styled from 'styled-components'

import * as animationData from './spinner.json'

const AnimationContainer = Styled.div`
  margin: 0;
  display: inline;
`

const LoadingSpinner = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  return (
    <AnimationContainer>
      <Lottie
        width="30px"
        height="30px"
        isClickToPauseDisabled
        options={defaultOptions}
        isStopped={false}
      />
    </AnimationContainer>
  )
}

export default LoadingSpinner
